// removed by extract-text-webpack-plugin
module.exports = {"textDanger":"_1LSVXa5vBI0OeFbCXaMCLm","spaceLeft":"_3fNHq-I_jQbS1gyJwpoiDR","spaceBoth":"Qjc-IGtfpOK-Rbz20XetU","spaceRight":"_2tZyB-MMb2IKs6lF8faWic"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/modules/_typography.scss
// module id = 206
// module chunks = 0